import { pattern } from '@carboledger/ui';
import { REGEX } from '@/config/regex.constants';
import { getTranslation } from '@/lib/utils/i18n';
import { USER_FIELDS } from './constants/admin.constants';
import { rolePicksManySites, rolePicksOneSite } from './constants/userRoles';

// RHF rules for the Add / Edit user form.
// TODO: a work-email rule to be added later — the server accepts any valid address.
export const userValidation = {
  [USER_FIELDS.email]: [pattern(REGEX.EMAIL, getTranslation('VALIDATION_EMAIL'))],
};

// Save stays disabled until every field the chosen role requires is filled.
export const hasRequiredUserFields = (values) => {
  const role = values[USER_FIELDS.role];
  if (!(values[USER_FIELDS.email] ?? '').trim() || !role) return false;
  if (rolePicksManySites(role)) return Boolean(values[USER_FIELDS.siteIds]?.length);
  if (rolePicksOneSite(role)) return Boolean(values[USER_FIELDS.siteId]);
  return true;
};
